<template>
  <div class="h-full flex column kanban-module">
    <div class="component-header wrapper w-full flex-zero">
      <e-row>
        <e-col class="flex">
          <div class="app-input-group">
            <div class="i-group only-icon">
              <u-btn class="active" icon="columns" icon-style="regular" icon-type="fa" title="Kanban" no-caps></u-btn>
              <u-btn icon="bars" title="Lista" icon-type="fa" icon-style="regular" no-caps></u-btn>
            </div>
          </div>
          <u-btn :disable="loading" label="+ Negócio" class="app-btn bg-green bold text-white m-l-sm no-shadow" size="sm" no-caps/>

        </e-col>
        <e-col class="flex justify-end">
          <funil-select :loading="loading" :funis="funis" :active="funil" @mudarFunil="mudarFunil"/>
        </e-col>
      </e-row>
    </div>

    <div class="kanban-container" v-if="!loading">
      <div class="kanban-content">
        <div class="kanban-funil-item" v-for="etapa in funil.etapas">
          <div class="funil-header">
            <div class="funil-header-content">
              <div class="full-width">
                <div>
                  <div class="etapa-title">{{ etapa.nome }}</div>
                </div>
                <div class="etapa-subtitle">
                  <div class="m-r-sm">
                    R$ 0
                  </div>
                  <div>
                    0 negócios
                  </div>
                </div>
              </div>
              <svg class="arrow" width="16" height="56" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path class="arrow__right" fill="#F7F7F7" d="M0 0h16v56H0z"></path>
                  <path class="arrow__border" fill="#E5E5E5" d="M1 0l8 28-8 28H0V0z"></path>
                  <path class="arrow__left" fill="#F7F7F7" d="M0 1l8 27-8 27z"></path>
                </g>
              </svg>
            </div>
          </div>
          <draggable v-if="!loadingKanban" :list="kanban[etapa.id]" class="funil-cards" group="kanban">
            <div class="card" draggable="true" v-for="(item, i) in kanban[etapa.id].result">
              <div class="card-content">
                {{ item.text }}
              </div>
            </div>
            <div class="card" draggable="true"></div>
            <u-btn icon="plus" icon-type="fa" icon-style="light" color="grey-9" dense
                   class="add-btn b-radius-3px full-width no-shadow" flat/>
          </draggable>
          <div class="funil-cards" v-else>
            <div class="card">
              <div class="card-content_">
                <u-fake-loader/>
                <u-fake-loader width="60%"/>
                <u-fake-loader width="10%"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kanban-container flex items-center justify-center" v-else>
      <sl-loading v-show="false" content="Kanban"/>
      <div>Ausência nas configurações do módulo CRM</div>
    </div>
  </div>
</template>

<script>
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import FunilSelect from "@/components/negocio/components/inputs/FunilSelect"
import {find} from "@/domain/negocio/services/funil"
import {listByFunil} from "@/domain/negocio/services/negocio"
import SlLoading from "@/components/layout/components/Loading"
import draggable from "vuedraggable"
import {UFakeLoader} from "uloc-vue"

export default {
  name: "Kanban",
  data() {
    return {
      loading: true,
      funis: null,
      funil: null,
      loadingKanban: true,
      kanban: null
    }
  },
  components: {
    SlLoading,
    FunilSelect,
    ERow,
    ECol,
    draggable,
    UFakeLoader
  },
  computed: {},
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      find()
          .then(response => {
            this.funis = response.data
            this.funil = this.active()
            this.$nextTick(() => {
              this.loading = false
              this.loadNegocios(this.funil)
            })
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    loadNegocios(funil) {
      this.loadingKanban = true
      listByFunil(funil.id, 1, 100, '')
          .then(response => {
            this.kanban = response.data
            this.$nextTick(() => {
              this.loadingKanban = false
            })
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    active() {
      if (!this.funis) return null
      const first = this.funis.slice().sort((a, b) => {
        return a.order - b.order
      })
      if (typeof first[0] !== 'undefined') {
        return first[0]
      }
      return null
    },
    mudarFunil(funil) {

    }
  }
}
</script>
